import { ButtonHTMLAttributes, ReactNode } from 'react';

type ButtonVariant = 'primary' | 'secondary' | 'ghost' | 'destructive';
type ButtonSize = 'default' | 'small';

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: ButtonVariant;
  size?: ButtonSize;
  children: ReactNode;
}

export function Button({
  variant = 'primary',
  size = 'default',
  children,
  disabled,
  className = '',
  ...props
}: ButtonProps) {
  const baseStyles = 'font-semibold transition-colors cursor-pointer inline-flex items-center justify-center focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-navy-900';

  const sizeStyles = {
    default: 'h-10 px-4 text-[14px]',
    small: 'h-8 px-3 text-[13px]',
  };

  const variantStyles = {
    primary: 'bg-[#1B365D] text-white hover:bg-[#152A4D] disabled:opacity-50 disabled:cursor-not-allowed',
    secondary: 'bg-white text-[#1B365D] border border-[#1B365D] hover:bg-[#F7FAFC] disabled:opacity-50 disabled:cursor-not-allowed',
    ghost: 'bg-transparent text-[#1B365D] hover:bg-[#F7FAFC] disabled:opacity-50 disabled:cursor-not-allowed',
    destructive: 'bg-[#DC2626] text-white hover:bg-[#B91C1C] disabled:opacity-50 disabled:cursor-not-allowed',
  };

  return (
    <button
      className={`${baseStyles} ${sizeStyles[size]} ${variantStyles[variant]} rounded ${className}`}
      disabled={disabled}
      {...props}
    >
      {children}
    </button>
  );
}
